<div class="flex flex-col gap-2 w-full min-w-0">
  <!-- File Preview Chips -->
  <div *ngIf="selectedFiles.length > 0" class="flex flex-wrap gap-1 sm:gap-2 max-h-24 overflow-y-auto">
    <div *ngFor="let selectedFile of selectedFiles; let i = index" class="file-preview-chip flex items-center gap-1 sm:gap-2 p-1.5 sm:p-2 bg-base-200 rounded-lg max-w-full sm:max-w-xs">
      <div class="flex items-center gap-1 sm:gap-2 flex-1 min-w-0">
        <div *ngIf="selectedFile.type === 'image'" class="avatar">
          <div class="w-6 sm:w-8 rounded">
            <img [src]="selectedFile.preview" alt="Preview" />
          </div>
        </div>
        <div *ngIf="selectedFile.type === 'file'" class="text-sm sm:text-lg">
          {{ getFileIcon(selectedFile.file.name) }}
        </div>
        <div class="flex-1 min-w-0">
          <p class="text-xs sm:text-sm font-medium truncate">{{ selectedFile.file.name }}</p>
          <p class="text-xs text-base-content/60">{{ (selectedFile.file.size / 1024 / 1024).toFixed(2) }} MB</p>
        </div>
      </div>
      <button
        class="btn btn-ghost btn-xs sm:btn-sm btn-circle text-error hover:bg-error hover:text-error-content flex-shrink-0"
        (click)="removeSelectedFile(i)"
      >
        <i class="ri-close-line text-sm"></i>
      </button>
    </div>
  </div>

  <!-- Input Actions -->
  <div class="flex w-full min-w-0 gap-2 items-end">
    <div class="flex-1 min-w-0 border border-gray-300 rounded-lg bg-white">
      <textarea
        #messageInput
        class="textarea textarea-ghost w-full min-w-0 resize-none overflow-y-auto leading-tight px-3 py-2 min-h-10 max-h-28 text-sm sm:text-base border-none focus:outline-none"
        rows="1"
        maxlength="1000"
        appInputAutoResize
        placeholder="Type a message"
        (input)="onInput()"
        (keydown)="onKeyPress($event)"
      ></textarea>
    </div>
    <button
      class="btn btn-sm btn-ghost btn-square text-zinc-500 hover:text-black font-normal text-base sm:text-lg flex-shrink-0"
      (click)="sendMessage()"
      [disabled]="isSending"
    >
      <i class="ri-send-plane-fill"></i>
    </button>
  </div>
</div>
